export default "__VITE_ASSET__BeP3MIsd__"